import { render, staticRenderFns } from "./routeList.vue?vue&type=template&id=51e314b4&scoped=true"
import script from "./routeList.vue?vue&type=script&lang=js"
export * from "./routeList.vue?vue&type=script&lang=js"
import style0 from "./routeList.vue?vue&type=style&index=0&id=51e314b4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51e314b4",
  null
  
)

export default component.exports